<template>
  <v-container class="fill-height" fluid style="min-height: 434px">
    <v-row>
      <v-col
        v-for="(item, index) in galleryItems"
        :key="index"
        cols="12"
        sm="6"
        md="4"
      >
        <v-card>
          <v-img :src="item.src" height="200" class="grey darken-4"></v-img>
          <v-card-title class="text-h6">{{ item.title }}</v-card-title>
          <v-expand-transition>
            <v-card-text v-if="item.expanded">
              {{ item.description }}
            </v-card-text>
          </v-expand-transition>
          <v-card-actions>
            <v-icon @click="toggleDescription(item)">
              {{ item.expanded ? "mdi-chevron-up" : "mdi-chevron-down" }}
            </v-icon>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      galleryItems: [
        {
          src: "https://gt-grupo.com/wp-content/uploads/2020/12/cuadro-vivienda-1.jpg",
          title:"Instalación de sistemas eléctricos residenciales",
          description:"Brindamos servicios especializados en la instalación de sistemas eléctricos para hogares, garantizando una distribución eficiente de energía. Desde el cableado hasta la configuración de interruptores y enchufes, nos encargamos de crear entornos eléctricos seguros y funcionales para su hogar.",
          expanded: true,
        },
        {
          src: "https://www.celerlight.com/wp-content/uploads/2021/06/iluminacion-exterior-vivienda.jpg",
          title: "Instalación de iluminación exterior",
          description:
            "Transformamos espacios exteriores con nuestra instalación de iluminación personalizada. Desde jardines hasta fachadas, creamos ambientes vibrantes y seguros, utilizando tecnología de vanguardia para resaltar la belleza de su propiedad durante la noche.",
          expanded: true,
        },
        {
          src: "https://d500.epimg.net/cincodias/imagenes/2022/02/10/legal/1644486055_549738_1644486109_noticia_normal.jpg",
          title: "Sistemas de energía renovable",
          description:
            " Únase a la revolución verde con nuestros sistemas de energía renovable. Instalamos paneles solares fotovoltaicos y sistemas eólicos de baja potencia para ayudarlo a reducir su huella de carbono y ahorrar en costos de energía a largo plazo.",
          expanded: true,
        },
        {
          src: "https://3.bp.blogspot.com/-oGqcZnHphTo/WOFgR4YAJTI/AAAAAAAAJek/jLq7uSQ-GiM6UTlCXRozEFix9NxNaE_PwCLcB/s1600/Humedad.jpg",
          title: "Reemplazo y actualización de cableado antiguo",
          description:
            " Modernice su sistema eléctrico reemplazando cables antiguos con nuestra experiencia en tecnologías seguras y eficientes. No solo mejoramos la confiabilidad de su red eléctrica, sino que también aseguramos que cumpla con las normativas actuales para un hogar o negocio seguro y actualizado.",
          expanded: true,
        },
        {
          src: "https://www.oscagas.es/wp-content/uploads/2022/01/Instalacion-de-Aire-Acondicionado.jpg",
          title: "Instalación de aires acondicionados",
          description:
"Asegure su confort en cualquier temporada con nuestros servicios de instalación de aires acondicionados. Desde sistemas de ventana hasta unidades divididas, nos encargamos de proporcionar soluciones eficientes y personalizadas para mantener su espacio fresco y agradable. Confié en nosotros para climatizar su entorno de manera efectiva y energéticamente eficiente.",
          expanded: true,
        },
        {
          src: "https://beroal.com/img/cms/antena-television_1.jpg",
          title: "Instalación de antenas",
          description:"Conéctese con el mundo de manera nítida y sin interferencias gracias a nuestros servicios de instalación de antenas. Desde antenas de televisión hasta antenas parabólicas para recepción satelital, nos encargamos de brindarle una señal sólida y de alta calidad. Optimizamos la posición y la configuración de las antenas para garantizar una recepción óptima de sus canales favoritos. Confíe en nosotros para llevar la mejor calidad de transmisión a su hogar u oficina.",
          expanded: true,
        },
      ],
    };
  },
  methods: {
    toggleDescription(item) {
      item.expanded = !item.expanded;
    },
  },
};
</script>
